import React from 'react';
function SvgEchIconCheck(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={19}
      height={15}
      viewBox="0 0 19 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1 8.63636L5.53333 13L18 1"
        stroke="#FF9A00"
        strokeWidth={2}
        strokeMiterlimit={10}
      />
    </svg>
  );
}
export default SvgEchIconCheck;
